module.exports = __webpack_public_path__ + "static/img/xqhz_10.a633405.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xqhz/xqhz_10.png
// module id = Ic0m
// module chunks = 180